import { Period } from '@/resources/models/period';
import { Recovery } from '@/resources/models/recovery';
import { UwvDecision } from '@/resources/models/uwv-decisions';
import Helpers from '@/shared/helpers/functions';
import States from '@/resources/models/states';

class ReportOfSickness {
  constructor (data = {}) {
    this.id = data.id;
    this.employeeId = data.employeeId;
    this.employerId = data.employerId;

    this.status = States[data.status];

    this.firstOfAbsence = data.firstSickDayIsoDate || new Date().toISOString().substr(0, 10);
    this.disabilityRate = Helpers.Percentage.parse(data.disabilityRateAsPercentage) || '100,00';
    this.safetyNet = data.safetyNet;
    this.accidentType = data.accidentType;
    this.arboReport = data.arboReport;

    this.reportDate = data.reportIsoDate;
    this.processedUntilDate = data.indemnityProcessedUntilIsoDate;

    this.periods = [];
    this.recovery = null;

    if (data.periods != null) {
      data.periods.sort((a, b) => {
        if (new Date(a.startIsoDate) > new Date(b.startIsoDate)) return 1;
        else if (new Date(b.startIsoDate) > new Date(a.startIsoDate)) return -1;
        else return 0;
      }).forEach(p => {
        if ([States.Removed, States.RemovedForCorrection].indexOf(p.status) === -1) {
          if (p.typeOfReport === 'Period') {
            this.periods.push(new Period(p));
          }

          if (p.typeOfReport === 'Recovery') {
            this.recovery = new Recovery(p);
          }
        }
      });
    }
    this.superficialStatus = this.recovery != null ? 'Closed' : 'Open';

    // backwards compatibility failsafe
    this.recoveryDate = this.recovery && this.recovery.recoveryDate;

    if (data.uwvDecisions) {
      this.uwvDecisions = data.uwvDecisions.map(u => new UwvDecision(u));
    } else this.uwvDecisions = [];
  }

  set accidentType (value) {
    if (value == null) {
      this.accident = null;
      this.thirdPartyLiability = null;
    } else if (value === AccidentTypes.None) {
      this.accident = false;
      this.thirdPartyLiability = null;
    } else if (value === AccidentTypes.NoThirdPartyLiability) {
      this.accident = true;
      this.thirdPartyLiability = false;
    } else if (value === AccidentTypes.ThirdPartyLiability) {
      this.accident = true;
      this.thirdPartyLiability = true;
    }
  }

  get accidentType () {
    if (this.accident === null) return null;

    if (this.accident) {
      if (this.thirdPartyLiability === true) {
        return AccidentTypes.ThirdPartyLiability;
      } else {
        return AccidentTypes.NoThirdPartyLiability;
      }
    } else {
      return AccidentTypes.None;
    }
  }

  getFormData () {
    let result = new FormData();
    const apiData = this.getApiData();
    for (let attribute in apiData) {
      if (apiData[attribute] !== undefined) {
        result.append(attribute, apiData[attribute]);
      }
    }
    return result;
  }

  getApiData () {
    return {
      id: this.id,
      employerId: this.employerId,
      employeeId: this.employeeId,
      firstSickDayIsoDate: this.firstOfAbsence,
      disabilityRateAsPercentage: parseFloat(this.disabilityRate.replace(',', '.')),
      safetyNet: this.safetyNet,
      accidentType: this.accidentType,
      arboReport: this.arboReport
    };
  }

  getSearchString () {
    return String(this.id) +
      String(this.employeeId) +
      String(this.employerId) +
      String(this.firstOfAbsence) +
      String(this.disabilityRate) +
      String(this.safetyNet) +
      String(this.accidentType) +
      Helpers.Dates.formatDate(this.firstOfAbsence) +
      Helpers.Dates.searchDates(this.firstOfAbsence);
  }
}

const AccidentTypes = {
  None: 'None',
  NoThirdPartyLiability: 'NoThirdPartyLiability',
  ThirdPartyLiability: 'ThirdPartyLiability'
};

export {
  ReportOfSickness,
  AccidentTypes
};
